module.exports = __webpack_public_path__ + "static/bluunext-bold-webfont-865df23640e3880c1c35f29c7c4bf7bb.woff2";